var cov_23qljmsniv = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Message/Container.tsx",
      hash = "469c2cc3fea7f13720f30f7dfa2628a235fb6925",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Message/Container.tsx",
    statementMap: {
      "0": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 16
        }
      },
      "1": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "2": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 54
        }
      },
      "3": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 43,
          column: 81
        }
      },
      "4": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 81
        }
      },
      "5": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "6": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 48,
          column: 7
        }
      },
      "7": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 19
        }
      },
      "8": {
        start: {
          line: 49,
          column: 19
        },
        end: {
          line: 49,
          column: 21
        }
      },
      "9": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 62,
          column: 7
        }
      },
      "10": {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 15
        }
      },
      "11": {
        start: {
          line: 56,
          column: 10
        },
        end: {
          line: 60,
          column: 11
        }
      },
      "12": {
        start: {
          line: 61,
          column: 10
        },
        end: {
          line: 61,
          column: 15
        }
      },
      "13": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 19
        }
      },
      "14": {
        start: {
          line: 69,
          column: 15
        },
        end: {
          line: 69,
          column: 26
        }
      },
      "15": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "16": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 55
        }
      },
      "17": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 88,
          column: 5
        }
      },
      "18": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 87,
          column: 29
        }
      },
      "19": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 86,
          column: 9
        }
      },
      "20": {
        start: {
          line: 80,
          column: 12
        },
        end: {
          line: 84,
          column: 14
        }
      },
      "21": {
        start: {
          line: 81,
          column: 14
        },
        end: {
          line: 83,
          column: 15
        }
      },
      "22": {
        start: {
          line: 82,
          column: 16
        },
        end: {
          line: 82,
          column: 32
        }
      },
      "23": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 65
        }
      },
      "24": {
        start: {
          line: 94,
          column: 21
        },
        end: {
          line: 100,
          column: 6
        }
      },
      "25": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 34
        }
      },
      "26": {
        start: {
          line: 95,
          column: 23
        },
        end: {
          line: 95,
          column: 34
        }
      },
      "27": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 98,
          column: 7
        }
      },
      "28": {
        start: {
          line: 97,
          column: 8
        },
        end: {
          line: 97,
          column: 28
        }
      },
      "29": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 18
        }
      },
      "30": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "31": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 28
        }
      },
      "32": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 33
        }
      },
      "33": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 42
        }
      },
      "34": {
        start: {
          line: 108,
          column: 18
        },
        end: {
          line: 108,
          column: 42
        }
      },
      "35": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 115,
          column: 5
        }
      },
      "36": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 28
        }
      },
      "37": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 114,
          column: 12
        }
      },
      "38": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "39": {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 125,
          column: 10
        }
      },
      "40": {
        start: {
          line: 121,
          column: 10
        },
        end: {
          line: 124,
          column: 11
        }
      },
      "41": {
        start: {
          line: 122,
          column: 12
        },
        end: {
          line: 122,
          column: 28
        }
      },
      "42": {
        start: {
          line: 123,
          column: 12
        },
        end: {
          line: 123,
          column: 39
        }
      },
      "43": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 130,
          column: 16
        }
      },
      "44": {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 129,
          column: 28
        }
      },
      "45": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 136,
          column: 5
        }
      },
      "46": {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 135,
          column: 46
        }
      },
      "47": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 20
        }
      },
      "48": {
        start: {
          line: 142,
          column: 25
        },
        end: {
          line: 142,
          column: 35
        }
      },
      "49": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 166,
          column: 5
        }
      },
      "50": {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 164,
          column: 14
        }
      },
      "51": {
        start: {
          line: 170,
          column: 0
        },
        end: {
          line: 170,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 35
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 33
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 42,
            column: 27
          },
          end: {
            line: 42,
            column: 28
          }
        },
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 81
          }
        },
        line: 43
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 23
          },
          end: {
            line: 45,
            column: 24
          }
        },
        loc: {
          start: {
            line: 45,
            column: 50
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 45
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 40
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 68
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 71,
            column: 12
          },
          end: {
            line: 71,
            column: 13
          }
        },
        loc: {
          start: {
            line: 71,
            column: 21
          },
          end: {
            line: 73,
            column: 7
          }
        },
        line: 71
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 77,
            column: 17
          },
          end: {
            line: 77,
            column: 18
          }
        },
        loc: {
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 87,
            column: 7
          }
        },
        line: 77
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 79,
            column: 16
          },
          end: {
            line: 79,
            column: 17
          }
        },
        loc: {
          start: {
            line: 79,
            column: 25
          },
          end: {
            line: 85,
            column: 11
          }
        },
        line: 79
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 80,
            column: 35
          },
          end: {
            line: 80,
            column: 36
          }
        },
        loc: {
          start: {
            line: 80,
            column: 51
          },
          end: {
            line: 84,
            column: 13
          }
        },
        line: 80
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        },
        loc: {
          start: {
            line: 92,
            column: 28
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 92
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 94,
            column: 48
          },
          end: {
            line: 94,
            column: 49
          }
        },
        loc: {
          start: {
            line: 94,
            column: 53
          },
          end: {
            line: 100,
            column: 5
          }
        },
        line: 94
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        loc: {
          start: {
            line: 111,
            column: 78
          },
          end: {
            line: 131,
            column: 3
          }
        },
        line: 111
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 119,
            column: 12
          },
          end: {
            line: 119,
            column: 13
          }
        },
        loc: {
          start: {
            line: 119,
            column: 21
          },
          end: {
            line: 126,
            column: 7
          }
        },
        line: 119
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 120,
            column: 31
          },
          end: {
            line: 120,
            column: 32
          }
        },
        loc: {
          start: {
            line: 120,
            column: 47
          },
          end: {
            line: 125,
            column: 9
          }
        },
        line: 120
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 128,
            column: 15
          },
          end: {
            line: 128,
            column: 16
          }
        },
        loc: {
          start: {
            line: 128,
            column: 21
          },
          end: {
            line: 130,
            column: 5
          }
        },
        line: 128
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 3
          }
        },
        loc: {
          start: {
            line: 133,
            column: 43
          },
          end: {
            line: 139,
            column: 3
          }
        },
        line: 133
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 141,
            column: 2
          },
          end: {
            line: 141,
            column: 3
          }
        },
        loc: {
          start: {
            line: 141,
            column: 11
          },
          end: {
            line: 167,
            column: 3
          }
        },
        line: 141
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 144,
            column: 19
          },
          end: {
            line: 144,
            column: 20
          }
        },
        loc: {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 164,
            column: 14
          }
        },
        line: 145
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 28
          },
          end: {
            line: 42,
            column: 44
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 42,
            column: 39
          },
          end: {
            line: 42,
            column: 44
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 35
          },
          end: {
            line: 43,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 46
          },
          end: {
            line: 43,
            column: 57
          }
        }, {
          start: {
            line: 43,
            column: 60
          },
          end: {
            line: 43,
            column: 66
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }, {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 46,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 46,
            column: 19
          }
        }, {
          start: {
            line: 46,
            column: 23
          },
          end: {
            line: 46,
            column: 32
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 28
          }
        }, {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 54,
            column: 15
          }
        }, {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 61,
            column: 15
          }
        }],
        line: 51
      },
      "5": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }],
        line: 76
      },
      "6": {
        loc: {
          start: {
            line: 81,
            column: 14
          },
          end: {
            line: 83,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 14
          },
          end: {
            line: 83,
            column: 15
          }
        }, {
          start: {
            line: 81,
            column: 14
          },
          end: {
            line: 83,
            column: 15
          }
        }],
        line: 81
      },
      "7": {
        loc: {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 34
          }
        }, {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 34
          }
        }],
        line: 95
      },
      "8": {
        loc: {
          start: {
            line: 96,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        }, {
          start: {
            line: 96,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        }],
        line: 96
      },
      "9": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }],
        line: 102
      },
      "10": {
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 42
          }
        }, {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 42
          }
        }],
        line: 108
      },
      "11": {
        loc: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        }, {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        }],
        line: 112
      },
      "12": {
        loc: {
          start: {
            line: 121,
            column: 10
          },
          end: {
            line: 124,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 10
          },
          end: {
            line: 124,
            column: 11
          }
        }, {
          start: {
            line: 121,
            column: 10
          },
          end: {
            line: 124,
            column: 11
          }
        }],
        line: 121
      },
      "13": {
        loc: {
          start: {
            line: 123,
            column: 19
          },
          end: {
            line: 123,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 19
          },
          end: {
            line: 123,
            column: 28
          }
        }, {
          start: {
            line: 123,
            column: 32
          },
          end: {
            line: 123,
            column: 33
          }
        }],
        line: 123
      },
      "14": {
        loc: {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        }],
        line: 134
      },
      "15": {
        loc: {
          start: {
            line: 157,
            column: 22
          },
          end: {
            line: 157,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 157,
            column: 30
          },
          end: {
            line: 157,
            column: 32
          }
        }, {
          start: {
            line: 157,
            column: 35
          },
          end: {
            line: 157,
            column: 37
          }
        }],
        line: 157
      },
      "16": {
        loc: {
          start: {
            line: 161,
            column: 13
          },
          end: {
            line: 161,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 13
          },
          end: {
            line: 161,
            column: 18
          }
        }, {
          start: {
            line: 161,
            column: 22
          },
          end: {
            line: 161,
            column: 38
          }
        }],
        line: 161
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Message/Container.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { PureComponent } from '../component';
import Alert from '../Alert';
import { messageClass } from './styles';
import { getUidStr } from '../utils/uid';

var Container =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Container, _PureComponent);

  var _super = _createSuper2(Container);

  function Container(props) {
    var _this;

    _classCallCheck(this, Container);

    cov_23qljmsniv.f[0]++;
    cov_23qljmsniv.s[0]++;
    _this = _super.call(this, props);
    _this.handleClassName = void 0;
    _this.handleStyle = void 0;
    cov_23qljmsniv.s[1]++;
    _this.state = {
      messages: []
    };
    cov_23qljmsniv.s[2]++;
    _this.removeMessage = _this.removeMessage.bind(_assertThisInitialized(_this));
    cov_23qljmsniv.s[3]++;

    _this.handleClassName = function () {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_23qljmsniv.b[0][0]++, 'top');
      var closeMsg = arguments.length > 1 ? arguments[1] : undefined;
      cov_23qljmsniv.f[1]++;
      cov_23qljmsniv.s[4]++;
      return messageClass('item', "item-".concat(closeMsg ? (cov_23qljmsniv.b[1][0]++, 'dismissed') : (cov_23qljmsniv.b[1][1]++, 'show'), "-").concat(position));
    };

    cov_23qljmsniv.s[5]++;

    _this.handleStyle = function (closeMsg, h, position) {
      cov_23qljmsniv.f[2]++;
      cov_23qljmsniv.s[6]++;

      if ((cov_23qljmsniv.b[3][0]++, !closeMsg) || (cov_23qljmsniv.b[3][1]++, h == null)) {
        cov_23qljmsniv.b[2][0]++;
        cov_23qljmsniv.s[7]++;
        return null;
      } else {
        cov_23qljmsniv.b[2][1]++;
      }

      var styles = (cov_23qljmsniv.s[8]++, {}); // if bottom, switch left or right

      cov_23qljmsniv.s[9]++;

      switch (position) {
        case 'bottom-right':
          cov_23qljmsniv.b[4][0]++;

        case 'bottom-left':
          cov_23qljmsniv.b[4][1]++;
          cov_23qljmsniv.s[10]++;
          break;

        default:
          cov_23qljmsniv.b[4][2]++;
          cov_23qljmsniv.s[11]++;
          styles = {
            zIndex: -1,
            opacity: 0,
            marginTop: -h
          };
          cov_23qljmsniv.s[12]++;
          break;
      }

      cov_23qljmsniv.s[13]++;
      return styles;
    };

    return _this;
  }

  _createClass(Container, [{
    key: "addMessage",
    value: function addMessage(msg) {
      var _this2 = this;

      cov_23qljmsniv.f[3]++;
      var id = (cov_23qljmsniv.s[14]++, getUidStr());
      cov_23qljmsniv.s[15]++;
      this.setState(immer(function (state) {
        cov_23qljmsniv.f[4]++;
        cov_23qljmsniv.s[16]++;
        state.messages.push(Object.assign({
          id: id
        }, msg));
      }));
      cov_23qljmsniv.s[17]++;

      if (msg.duration > 0) {
        cov_23qljmsniv.b[5][0]++;
        cov_23qljmsniv.s[18]++;
        setTimeout(function () {
          cov_23qljmsniv.f[5]++;
          cov_23qljmsniv.s[19]++;

          _this2.setState(immer(function (state) {
            cov_23qljmsniv.f[6]++;
            cov_23qljmsniv.s[20]++;
            state.messages.forEach(function (m) {
              cov_23qljmsniv.f[7]++;
              cov_23qljmsniv.s[21]++;

              if (m.id === id) {
                cov_23qljmsniv.b[6][0]++;
                cov_23qljmsniv.s[22]++;
                m.dismiss = true;
              } else {
                cov_23qljmsniv.b[6][1]++;
              }
            });
          }));
        }, msg.duration * 1000);
      } else {
        cov_23qljmsniv.b[5][1]++;
      }

      cov_23qljmsniv.s[23]++;
      return this.closeMessageForAnimation.bind(this, id, 200, 200);
    }
  }, {
    key: "removeMessage",
    value: function removeMessage(id) {
      cov_23qljmsniv.f[8]++;
      var callback;
      var messages = (cov_23qljmsniv.s[24]++, this.state.messages.filter(function (m) {
        cov_23qljmsniv.f[9]++;
        cov_23qljmsniv.s[25]++;

        if (m.id !== id) {
          cov_23qljmsniv.b[7][0]++;
          cov_23qljmsniv.s[26]++;
          return true;
        } else {
          cov_23qljmsniv.b[7][1]++;
        }

        cov_23qljmsniv.s[27]++;

        if (m.onClose) {
          cov_23qljmsniv.b[8][0]++;
          cov_23qljmsniv.s[28]++;
          callback = m.onClose;
        } else {
          cov_23qljmsniv.b[8][1]++;
        }

        cov_23qljmsniv.s[29]++;
        return false;
      }));
      cov_23qljmsniv.s[30]++;

      if (messages.length === 0) {
        cov_23qljmsniv.b[9][0]++;
        cov_23qljmsniv.s[31]++;
        this.props.onDestory();
      } else {
        cov_23qljmsniv.b[9][1]++;
        cov_23qljmsniv.s[32]++;
        this.setState({
          messages: messages
        });
      }

      cov_23qljmsniv.s[33]++;

      if (callback) {
        cov_23qljmsniv.b[10][0]++;
        cov_23qljmsniv.s[34]++;
        callback();
      } else {
        cov_23qljmsniv.b[10][1]++;
      }
    }
  }, {
    key: "closeMessageForAnimation",
    value: function closeMessageForAnimation(id, duration, msgHeight) {
      var _this3 = this;

      cov_23qljmsniv.f[10]++;
      cov_23qljmsniv.s[35]++;

      if (!duration) {
        cov_23qljmsniv.b[11][0]++;
        cov_23qljmsniv.s[36]++;
        this.removeMessage(id);
        cov_23qljmsniv.s[37]++;
        return;
      } else {
        cov_23qljmsniv.b[11][1]++;
      } // duration animation duration time


      cov_23qljmsniv.s[38]++;
      this.setState(immer(function (state) {
        cov_23qljmsniv.f[11]++;
        cov_23qljmsniv.s[39]++;
        state.messages.forEach(function (m) {
          cov_23qljmsniv.f[12]++;
          cov_23qljmsniv.s[40]++;

          if (m.id === id) {
            cov_23qljmsniv.b[12][0]++;
            cov_23qljmsniv.s[41]++;
            m.dismiss = true;
            cov_23qljmsniv.s[42]++;
            m.h = ((cov_23qljmsniv.b[13][0]++, msgHeight) || (cov_23qljmsniv.b[13][1]++, 0)) + 20; // messageHeight + messageMargin
          } else {
            cov_23qljmsniv.b[12][1]++;
          }
        });
      }));
      cov_23qljmsniv.s[43]++;
      setTimeout(function () {
        cov_23qljmsniv.f[13]++;
        cov_23qljmsniv.s[44]++;

        _this3.removeMessage(id);
      }, duration);
    }
  }, {
    key: "closeEvent",
    value: function closeEvent(id, duration) {
      cov_23qljmsniv.f[14]++;
      cov_23qljmsniv.s[45]++;

      if (duration === 0) {
        cov_23qljmsniv.b[14][0]++;
        cov_23qljmsniv.s[46]++;
        return this.removeMessage.bind(this, id);
      } else {
        cov_23qljmsniv.b[14][1]++;
      }

      cov_23qljmsniv.s[47]++;
      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      cov_23qljmsniv.f[15]++;

      var _ref = (cov_23qljmsniv.s[48]++, this.state),
          messages = _ref.messages;

      cov_23qljmsniv.s[49]++;
      return [messages.map(function (_ref2) {
        var id = _ref2.id,
            type = _ref2.type,
            content = _ref2.content,
            dismiss = _ref2.dismiss,
            h = _ref2.h,
            title = _ref2.title,
            top = _ref2.top,
            className = _ref2.className,
            position = _ref2.position,
            hideClose = _ref2.hideClose;
        cov_23qljmsniv.f[16]++;
        cov_23qljmsniv.s[50]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            key: id,
            className: "".concat(_this4.handleClassName(position, dismiss), " ").concat(className),
            style: _this4.handleStyle(dismiss, h, position),
            __self: _this4,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 145,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement(Alert, {
            outAnimation: true,
            className: messageClass('msg'),
            dismiss: dismiss,
            hideClose: hideClose,
            onClose: _this4.closeMessageForAnimation.bind(_this4, id),
            icon: true,
            iconSize: title ? (cov_23qljmsniv.b[15][0]++, 20) : (cov_23qljmsniv.b[15][1]++, 14),
            style: {
              top: top
            },
            type: type,
            __self: _this4,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 150,
              columnNumber: 11
            }
          }, (cov_23qljmsniv.b[16][0]++, title) && (cov_23qljmsniv.b[16][1]++,
          /*#__PURE__*/
          React.createElement("h3", {
            __self: _this4,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 161,
              columnNumber: 23
            }
          }, title)), content))
        );
      })];
    }
  }]);

  return Container;
}(PureComponent);

Container.displayName = void 0;
cov_23qljmsniv.s[51]++;
Container.displayName = 'ShineoutMessage';
export default Container;